import { Component, Element, h, Host, Listen, State } from '@stencil/core';

@Component({
  tag: 'mama-offcanvas',
})
export class MamaOffcanvas {
  @Element() el!: HTMLElement;
  @State() isStart = false;

  private backdrop: HTMLElement;

  componentWillLoad() {
    this.setActiveClass(this.el.querySelector('.link[href="' + window.location.pathname + '"]') as HTMLElement);
    this.onOffcanvasChanged();
  }

  componentDidLoad() {
    this.backdrop = document.querySelector('.offcanvas-backdrop');
    this.backdrop.addEventListener('click', () => {
      document.body.classList.remove('offcanvas-active');
    });
  }

  @Listen('offcanvasChanged')
  onOffcanvasChanged() {
    this.isStart = this.el.querySelectorAll('.active').length <= 0;
  }

  // Due to hide from url paths we need to recursively go up the tree from the current url
  setActiveClass(element: HTMLElement) {
    if (element) {
      let parent = element.closest('.offcanvas') as HTMLElement;

      // closest will start with checking itself which would always be true after the first run
      if (parent === element) {
        parent = parent.parentElement.closest('.offcanvas') as HTMLElement;
      }

      // We don't want to set active on root offcanvas because it will open it on page load
      if (parent && parent.id !== 'offcanvas') {
        parent.classList.add('active');
        this.setActiveClass(parent);
      } else {
        // Remove offcanvas-start class that offcanvas-header has the correct state
        parent.classList.remove('offcanvas-start');
      }
    }
  }

  render() {
    return (
      <Host
        class={{
          'offcanvas-start': this.isStart,
        }}
      >
        <slot />
      </Host>
    );
  }
}
